import type { Column, ColumnKey } from '@/types'

type ColumnLike = Pick<Column, 'key'> & Partial<Pick<Column, 'pk' | 'fk' | 'uq'>>

export function getColumnKeyFlags(column: ColumnLike): { pk: boolean; fk: boolean; uq: boolean } {
  const pk = Boolean(column.pk ?? column.key === 'PK')
  const fk = Boolean((column.fk ?? column.key === 'FK') && !pk)
  const uq = Boolean((column.uq ?? (column.key === 'UQ')) || pk)

  return {
    pk,
    fk,
    uq: pk || uq,
  }
}

export function deriveLegacyColumnKey(column: ColumnLike): ColumnKey {
  const { pk, fk, uq } = getColumnKeyFlags(column)
  if (pk) return 'PK'
  if (fk) return 'FK'
  if (uq) return 'UQ'
  return ''
}

export function isPrimaryKey(column: ColumnLike): boolean {
  return getColumnKeyFlags(column).pk
}

export function isForeignKey(column: ColumnLike): boolean {
  return getColumnKeyFlags(column).fk
}

export function isUniqueKey(column: ColumnLike): boolean {
  return getColumnKeyFlags(column).uq
}

export function getColumnKeyLabels(column: ColumnLike): ColumnKey[] {
  const { pk, fk, uq } = getColumnKeyFlags(column)
  const labels: ColumnKey[] = []
  if (pk) labels.push('PK')
  if (fk) labels.push('FK')
  if (uq) labels.push('UQ')
  return labels
}
